import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireQuizAnswer} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class QuizAnswerService implements CrudService<UmpireQuizAnswer> {
  constructor(readonly http: TisaUmpireHttpService) {}

  update(
    body: Partial<UmpireQuizAnswer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizAnswer>> {
    return this.http
      .patch(`/quiz_answers/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireQuizAnswer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizAnswer>> {
    return this.http
      .post('/quiz_answers', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/quiz_answers/${id}`);
  }
}
